import React from 'react';
interface ExchangeOrder {
  serialNo: number;
  eoRef: string;
  tourCode: string;
  issueDate: string;
  dueDate: string;
  currency: string;
  amount: number;
}
interface BillExchangeOrdersProps {
  orders: ExchangeOrder[];
}
export function BillExchangeOrders({
  orders
}: BillExchangeOrdersProps) {
  const formatCurrency = (amount: number, currency: string) => {
    return `${currency} ${amount.toFixed(2)}`;
  };
  return <div className="mb-8" data-id="element-28">
      <h3 className="text-sm font-bold text-neutral-900 uppercase tracking-wide mb-4 pb-2 border-b-2 border-neutral-300" data-id="element-29">
        Exchange Orders Associated with this Bill
      </h3>

      {/* Table Header */}
      <div className="grid grid-cols-12 gap-4 pb-3 border-b-2 border-neutral-300 mb-4" data-id="element-30">
        <div className="col-span-1 text-sm font-semibold text-neutral-700 uppercase tracking-wide" data-id="element-31">
          S/N
        </div>
        <div className="col-span-2 text-sm font-semibold text-neutral-700 uppercase tracking-wide" data-id="element-32">
          EO Ref
        </div>
        <div className="col-span-2 text-sm font-semibold text-neutral-700 uppercase tracking-wide" data-id="element-33">
          Tour Code
        </div>
        <div className="col-span-2 text-sm font-semibold text-neutral-700 uppercase tracking-wide" data-id="element-34">
          Issue Date
        </div>
        <div className="col-span-2 text-sm font-semibold text-neutral-700 uppercase tracking-wide" data-id="element-35">
          Due Date
        </div>
        <div className="col-span-1 text-sm font-semibold text-neutral-700 uppercase tracking-wide text-center" data-id="element-36">
          Currency
        </div>
        <div className="col-span-2 text-sm font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-37">
          Amount
        </div>
      </div>

      {/* Exchange Order Rows */}
      {orders.map((order, index) => <div key={index} className="grid grid-cols-12 gap-4 py-3 border-b border-neutral-200 last:border-b-0" data-id="element-38">
          <div className="col-span-1 text-sm text-neutral-900" data-id="element-39">
            {order.serialNo}
          </div>
          <div className="col-span-2 text-sm text-neutral-900 font-semibold" data-id="element-40">
            {order.eoRef}
          </div>
          <div className="col-span-2 text-sm text-neutral-900" data-id="element-41">
            {order.tourCode}
          </div>
          <div className="col-span-2 text-sm text-neutral-900" data-id="element-42">
            {order.issueDate}
          </div>
          <div className="col-span-2 text-sm text-neutral-900" data-id="element-43">
            {order.dueDate}
          </div>
          <div className="col-span-1 text-sm text-neutral-900 text-center font-semibold" data-id="element-44">
            {order.currency}
          </div>
          <div className="col-span-2 text-sm font-semibold text-neutral-900 text-right tabular-nums" data-id="element-45">
            {formatCurrency(order.amount, order.currency)}
          </div>
        </div>)}
    </div>;
}